import React, { useMemo } from 'react';
import { Input, Select } from 'antd';
import { useQuery } from 'react-query';
import { SelectProps } from 'antd/lib/select';
import { isEmpty, noop } from 'lodash';

import { getParGuarantyByCriteria, ParGuaranty } from 'services/guaranty';

const { Option } = Select;

export type GuarSelectProps = SelectProps<any> & {
  onSelected?: (parguar: ParGuaranty) => void;
  allowClear?: any;
  guartype?: any;
  oncreate?: boolean;
};

const GuarCodeSelect = ({
  value,
  onChange = noop,
  onSelected,
  allowClear,
  guartype,
  oncreate = false,
}: GuarSelectProps) => {
  const params = useMemo(
    () => ({
      guarlabel: '',
      guartype: guartype ?? '',
    }),
    [guartype]
  );

  const { data, isFetching } = useQuery(
    ['getParGuarantyByCriteria', params],
    () => getParGuarantyByCriteria(params).then((res) => res.list || [])
  );
  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item) => item.guarcode === value)!);
    }
  };

  return !isEmpty(data) ? (
    <Select
      allowClear={allowClear}
      onChange={handleChange}
      loading={isFetching}
      showSearch
      value={value ?? ''}
      style={{width:'100%'}}  
    >
      {data?.map((item, index) => (
        <Option key={index} value={item.guarcode}>
          {item.guarlabel}
        </Option>
      ))}
    </Select>
  ) : !oncreate ? (
    <Select
      allowClear={allowClear}
      onChange={handleChange}
      loading={isFetching}
      showSearch
      value={value ?? ''}
    >
      {data?.map((item, index) => (
        <Option key={index} value={item.guarcode}>
          {item.guarlabel}
        </Option>
      ))}
    </Select>
  ) : (
    <Input
      onChange={(val) => {
        onChange(val.target.value, null as any);
      }}
    />
  );
};

export default GuarCodeSelect;
